"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactDnd = require("react-dnd");
var _SourceItems = require("../../constants/SourceItems");
var _SourceList = require("./SourceList.styled");
var _propTypes = require("prop-types");
var SourceListDnd = function SourceListDnd(_ref) {
  var children = _ref.children,
    isSourcePerformanceEnabled = _ref.isSourcePerformanceEnabled;
  var _useDrop = (0, _reactDnd.useDrop)({
      accept: _SourceItems.ItemTypes.SOURCE
    }),
    _useDrop2 = (0, _slicedToArray2["default"])(_useDrop, 2),
    drop = _useDrop2[1];
  return /*#__PURE__*/_react["default"].createElement(_SourceList.SourceListWrapper, {
    ref: drop,
    id: "source-list-wrapper",
    isSourcePerformanceEnabled: isSourcePerformanceEnabled
  }, children);
};
SourceListDnd.propTypes = {
  children: _propTypes.PropTypes.node,
  isSourcePerformanceEnabled: _propTypes.PropTypes.bool
};
var _default = exports["default"] = SourceListDnd;